import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";
import LandingPage from "./pages/LandingPage";
import InDevelopmentPage from "./pages/InDevelopmentPage";

const pageVariants = {
  initial: { opacity: 0, scale: 0.99, y: 10 },
  animate: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.99, y: -10 }
};

const pageTransition = {
  type: "spring",
  stiffness: 90,
  damping: 18,
  duration: 0.5
};

function AnimatedAppRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
              className="w-full"
            >
              <LandingPage />
            </motion.div>
          }
        />
        <Route
          path="/development"
          element={
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              transition={pageTransition}
              className="w-full"
            >
              <InDevelopmentPage />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <AnimatedAppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;